<template>
  <div
    v-if="(menu.user.is_subscribed || menu.user.is_on_trial || menu.user.type==1) && isMenuOwner"
    class="text-center mt-3 container-sm"
  >
    <div class="d-flex align-items-center justify-content-center">
      <div
        class="position-relative mr-2"
        v-if="menu.categories.length"
      >
        <router-link
          class="btn btn-primary mb-1 animate__animated animate__fadeIn"
          :to="{
                                    name: 'menuItemsAdd',
                                    params: { userSlug: menu.user.slug }
                                }"
        ><span class="d-none d-lg-inline-block">Add Menu</span><span class="d-lg-none d-inline-block"><i class="far fa-plus"></i></span>
          Item</router-link>
        <div>
          <div
            class="p-3 onboard-tile shadow-sm bg-white text-black text-left rounded d-flex small"
            v-if="
                                        rawMenu.categories.length &&
                                            !menuHasItems &&
                                            onboard.item
                                    "
          >
            <div class="mr-3 color-1 fa-2x">
              <i class="fad fa-lightbulb-on"></i>
            </div>
            <div>
              <div class="h4">
                Add items to your categories
              </div>
              <p>
                Use this button to add items to your
                categories e.g Chunky fries,
                Hamburger etc.
              </p>
              <button
                v-on:click="onboard.item = false"
                class="btn btn-primary btn-sm"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="position-relative">
        <router-link
          class="btn btn-primary mb-1 animate__animated animate__fadeIn"
          :to="{
                                    name: 'menuCategoriesAdd',
                                    params: { userSlug: menu.user.slug }
                                }"
        ><span class="d-none d-lg-inline-block">Add</span><span class="d-lg-none d-inline-block"><i class="far fa-plus"></i></span>
          Category</router-link>
        <div>
          <div
            class="p-3 onboard-tile shadow-sm bg-white text-black text-left rounded d-flex small"
            v-if="
                                        !menu.categories.length &&
                                            onboard.category
                                    "
          >
            <div class="mr-3 color-1 fa-2x">
              <i class="fad fa-lightbulb-on"></i>
            </div>
            <div>
              <div class="h4">Create a category</div>
              <p>
                First step is to create your
                categories e.g Breakfast, Lunch,
                Drinks etc. After you create a
                category you will be able to put
                items into it e.g Fries, Pancakes
                etc.
              </p>
              <button
                v-on:click="
                                                onboard.category = false
                                            "
                class="btn btn-primary btn-sm"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2 font-weight-bold">
      <a
        class="mr-4"
        :href="'/' + rawMenu.user.slug + '/menu/options'"
      >
        Add-ons
      </a> <a
        class=""
        :href="'/' + rawMenu.user.slug + '/menu/cross-sell-groups'"
      >
        Cross sells
      </a>
    </div>
  </div>
</template>

<script>
import menuMixin from "../../../mixins/menuMixin";
export default {
  data() {
    return {
      onboard: {
        category: true,
        item: true,
      },
    };
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  mixins: [menuMixin],
};
</script>
